import type { IKpiRepository, KpiReorderInput } from '../repositories/IKpiRepository.js';

interface Deps { kpiRepository: IKpiRepository; }

export function createReorderKpisUseCase({ kpiRepository }: Deps) {
  return async function reorderKpis(updates: KpiReorderInput): Promise<void> {
    return kpiRepository.reorder(updates);
  };
}
